import React from 'react';

var AddLoan = function AddLoan() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "45",
    height: "45",
    viewBox: "0 0 45 45",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 43.3333C34.0059 43.3333 43.3333 34.0059 43.3333 22.5C43.3333 10.9941 34.0059 1.66667 22.5 1.66667C10.9941 1.66667 1.66667 10.9941 1.66667 22.5C1.66667 34.0059 10.9941 43.3333 22.5 43.3333ZM22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#005FB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 12.5C23.3333 12.0398 22.9602 11.6667 22.5 11.6667C22.0398 11.6667 21.6667 12.0398 21.6667 12.5V21.6667H11.6667C11.2064 21.6667 10.8333 22.0398 10.8333 22.5C10.8333 22.9602 11.2064 23.3333 11.6667 23.3333H21.6667V33.3333C21.6667 33.7936 22.0398 34.1667 22.5 34.1667C22.9602 34.1667 23.3333 33.7936 23.3333 33.3333V23.3333H32.5C32.9602 23.3333 33.3333 22.9602 33.3333 22.5C33.3333 22.0398 32.9602 21.6667 32.5 21.6667H23.3333V12.5Z",
    fill: "#005FB9"
  }));
};

export default AddLoan;